/**
 * Funnel shortcuts.
 */
import { Funnels } from "../../features/analytics/funnels";

export class FunnelTracker {
  constructor(public readonly client: Funnels) {}

  /** Define a new funnel (admin / setup). */
  define(definition: Parameters<Funnels["define"]>[0]) {
    return this.client.define(definition);
  }

  /** Record a step completion in a funnel. */
  step(funnelId: string, step: string, stepNumber: number, userId?: string, properties?: Record<string, unknown>) {
    return this.client.trackStep({ funnelId, step, stepNumber, userId, properties });
  }

  /** Mark a funnel as completed. */
  complete(funnelId: string, userId?: string, properties?: Record<string, unknown>) {
    return this.client.trackComplete(funnelId, userId, properties);
  }

  /** Mark a funnel as abandoned. */
  abandon(funnelId: string, lastStep: string, userId?: string, reason?: string) {
    return this.client.trackAbandon(funnelId, lastStep, userId, reason);
  }
}
